<ng-container *ngIf="!isShortText; else shortText">
  <textarea
    #input
    autofocus
    id="long-text"
    [maxLength]="maxCharacters"
    wrap="soft"
    placeholder="{{ placeholderText }}"
    [(ngModel)]="textValue"
    (input)="onTyping(input.value)"
    data-e2e="textField"></textarea>
  <div class="character-count" *ngIf="textValue != null && maxCharacters > 0">
    <span>{{ textValue.length }} / {{ maxCharacters }}</span>
  </div>
</ng-container>
<ng-template #shortText>
  <input
    #input
    type="text"
    [maxLength]="maxCharacters"
    (input)="onTyping(input.value)"
    [(ngModel)]="textValue"
    placeholder="{{ placeholderText }}"
    data-e2e="textField" />
</ng-template>
